import { uploadFiles } from "@api/files";
import { AUTH_ERROR_MESSAGE } from "config/api";
import useAuth from "@hooks/Auth/useAuth";
import useModalActions from "@hooks/common/useModalAction";
import { APIError } from "@models/index";
import { useMutation } from '@tanstack/react-query';
import { isAuthError } from "@api/api";

export default function useUploadFiles() {
  const { accessToken, refreshTokens } = useAuth();
  const {
    successAction,
    errorAction,
    waitingAction,
    closeLoadingModal,
  } = useModalActions();

  const showError = async (error: APIError) => {
    if (isAuthError(error)) {
      await errorAction(error, AUTH_ERROR_MESSAGE, refreshTokens);
      return;
    }

    if (error.response?.status === 422) {
      await errorAction(error, "Can't Upload File Type");
      return;
    }

    await errorAction(error, "Can't Upload Files");
  };

  const { mutate: upload, isPending } = useMutation({
    mutationFn: ({ files }: { files: File[] }) =>
      uploadFiles({ accessToken, files }),
    onMutate: () => {
      waitingAction({ message: "Uploading" });
    },
    onSuccess: async () => {
      closeLoadingModal();
      await successAction("Upload Success");
    },
    onError: async (error: APIError) => {
      closeLoadingModal();
      await showError(error);
    },
    retry: false,
  });

  return { upload, isPending };
}
